import React from 'react'

function Navbar() {
  return (
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" id="sideNav">
        <a class="navbar-brand js-scroll-trigger" href="#page-top">
            <span class="d-block d-lg-none">Andrea Sánchez Velasco</span>
            <span class="d-none d-lg-block"><img class="img-fluid img-profile rounded-circle mx-auto mb-2" src="perfil.jpg" alt="..." /></span>
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav">
                <li class="nav-item"><a class="nav-link js-scroll-trigger" href="#about">Sobre mí</a></li>
                <li class="nav-item"><a class="nav-link js-scroll-trigger" href="#experience">Mi Experiencia</a></li>
                <li class="nav-item"><a class="nav-link js-scroll-trigger" href="#education">Mi Formación</a></li>
                <li class="nav-item"><a class="nav-link js-scroll-trigger" href="#skills">Mis habilidades</a></li>
                <li class="nav-item"><a class="nav-link js-scroll-trigger" href="#proyectos">Mis Proyectos</a></li>
            </ul>
        </div>
    </nav>

    )
}

export default Navbar